import React from 'react';

import { hockeyFormatter } from '@nhl/formatter-utilities';

import { TeamDisplayModule } from '../../../../components';

const GAME_FORMAT = { regulationPeriods: 3 };

const columnDefinitions = [
    {
        Header: 'Season',
        accessor: 'seasonId',
        Cell: ({ value }) => hockeyFormatter.singleSeasonFormatter(value),
        maxWidth: 80,
    },
    {
        Header: 'Winning Team',
        accessor: 'winningTeam.fullName',
        Cell: ({ original }) => <TeamDisplayModule team={original.winningTeam} season={original.seasonID} useInTable />,
        minWidth: 180,
        sortType: (a, b) => a.original.winningTeam.fullName.localeCompare(b.original.winningTeam.fullName),
    },
    {
        Header: 'GWG Scorer',
        accessor: 'gameWinningGoalPlayerName',
        minWidth: 150,
    },
    {
        Header: 'Position',
        accessor: 'position',
        maxWidth: 80,
    },
    {
        Header: 'Game #',
        accessor: 'gameNumber',
        Cell: ({ value }) => (value + '')[2],
        maxWidth: 80,
    },
    {
        Header: 'Time of Goal',
        accessor: 'gameWinningGoalTime',
        maxWidth: 100,
    },
    {
        Header: 'Period',
        accessor: 'gameWinningGoalPeriod',
        Cell: ({ value }) => hockeyFormatter.periodsFormatter(Number(value), GAME_FORMAT),
        maxWidth: 80,
    },
    {
        Header: 'Opposing Team',
        accessor: 'losingTeam.fullName',
        Cell: ({ original }) => <TeamDisplayModule team={original.losingTeam} season={original.seasonID} useInTable />,
        minWidth: 180,
        sortType: (a, b) => a.original.losingTeam.fullName.localeCompare(b.original.losingTeam.fullName),
    },
    {
        Header: 'Goaltender',
        accessor: 'goaltenderName',
        minWidth: 150,
    },
    {
        id: 'finalScore',
        Header: 'Final Score',
        Cell: ({ original }) => {
            const homeTeam =
                original.homeTeamId === original.winningTeamId ? original.winningTeam : original.losingTeam;
            const visitingTeam =
                original.visitingTeamId === original.winningTeamId ? original.winningTeam : original.losingTeam;
            return `${visitingTeam.triCode} ${original.visitingScore} at ${homeTeam.triCode} ${original.homeScore}`;
        },
        minWidth: 115,
    },
];

export default columnDefinitions;
